module.exports = __webpack_public_path__ + "img/MHH-FC-Background.07065375.png";